const Resodate: React.FC = () => {
  return <div>Hello Resodate</div>;
};

export default Resodate;
